import React from 'react';
import { ErrorPage } from '@hydra/common/error';
import { useErrorContext } from '@hydra/common/context';

export const ErrorBoundary = ({ children, ...props }) => {
  const { error } = useErrorContext();

  return (error
    ? <ErrorPage {...props} error={error} />
    : children
  );
};

export default ErrorBoundary;
